import { GetMyPersonalityTestAnswersDto } from "@/api/generated/generatedTypes";
import { Button, Stack, Text } from "@mantine/core";

interface PersonalityTestSectionProps {
  requestId: number;
  answers: GetMyPersonalityTestAnswersDto[];
  isVisible: boolean;
  onToggle: () => void;
}

export const PersonalityTestSection = ({
  answers,
  isVisible,
  onToggle,
}: PersonalityTestSectionProps) => {
  return (
    <>
      <Button variant="outline" size="xs" onClick={onToggle}>
        {isVisible ? "Personality Test 숨기기" : "Personality Test 보기"}
      </Button>

      {isVisible && (
        <Stack gap="xs">
          {answers?.map((answer) => (
            <Text c="black" size="sm" key={answer.id}>
              <Text span fw={700} c="black">
                {answer.question.title}:
              </Text>{" "}
              {answer.answerText ||
                answer.answerScale ||
                answer.selectedOptions.map((o) => o.option.displayText).join(", ")}
            </Text>
          ))}
        </Stack>
      )}
    </>
  );
};

